import styled from '@emotion/styled'
import { hoverOpacity } from '../../theme'

interface Props {
  autoSubmit?: boolean
  marginRight?: boolean
  variant?: 'primary' | 'danger' | 'default' | 'inverted'
}

const ButtonSubmit = styled.button<Props>(
  ({ theme }) => theme.fontSmooth,
  (props) => ({
    backgroundColor: props.theme.colors.primary,
    border: 'none',
    borderRadius: '5px',
    color: 'white',
    cursor: 'pointer',
    fontFamily: props.theme.fonts.families.body,
    fontSize: '14px',
    fontWeight: 700,
    letterSpacing: '1.05px',
    lineHeight: '18px',
    marginBottom: '1em',
    minWidth: '126px',
    padding: '12px 30px',
    textTransform: 'uppercase',
    [props.theme.mediaQueries.maxTablet]: {
      fontSize: '12px',
      padding: '10px 15px',
    },
    ...hoverOpacity,
  }),
  ({ variant, theme }) =>
    variant === 'inverted' && {
      border: `1px solid ${theme.colors.primary}`,
      color: theme.colors.primary,
      backgroundColor: theme.colors.white,
    },
  ({ variant, theme }) =>
    variant === 'danger' && {
      backgroundColor: theme.colors.danger,
    },
  ({ variant, theme }) =>
    variant === 'default' && {
      backgroundColor: theme.colors.iconGray,
    },
  (props) =>
    props.disabled && {
      cursor: 'not-allowed',
      background: props.theme.colors.grays.grayDark,
      ':hover': {
        opacity: 1,
      },
    },
  ({ marginRight }) =>
    marginRight && {
      marginRight: '1em',
    }
)

export default ButtonSubmit
